

var storefrontTimingsCalculator = require('../../../utils/domain/storefront/storefrontTimingsCalculator');
var dateUtil = require('../../../utils/dateUtil/dateUtil');

export function getExpectedHandoverTime(sale, additionalTime)
{
    if (additionalTime == null)
        additionalTime = 0;

    var handOverDateTime = storefrontTimingsCalculator.calculateEstimatedHandoverTime(sale);
    handOverDateTime = dateUtil.addMinutes(dateUtil.getNow(), handOverDateTime);

    if (dateUtil.isAfter(sale.currentPlannedDispatchDateTime, handOverDateTime))
        handOverDateTime = sale.currentPlannedDispatchDateTime;

    handOverDateTime = dateUtil.addMinutes(handOverDateTime, additionalTime);
    return handOverDateTime;
}

export function getFormattedDateTimeToLocalTime(dateTime)
{
    return dateUtil.formatDate(dateUtil.convertToLocalStandard(dateTime), "HH:mm");
}